/* eslint-disable */
// @formatter:off
export const ospanDefinition = {
  steps: [
  {
    type: 'INFO_INPUT',
    props: {
      textLines: [
        {
          orderNum: 1,
          text: 'The Acumen assessment evaluates the ability to make judgments and quick decisions using memory, attention, and recall skills.',
        },
        {
          orderNum: 2,
          text: 'Below are some tips for completing this two-part cognitive assessment:',
          bullets: [
            'Find a quiet place and eliminate any distractions',
            'The tasks will require your complete attention',
            'If you exit the assessment, you will not be able to resume your place in the assessment',
            'Do NOT write anything down during the Acumen Test - doing so will invalidate your results',
          ],
        },
        {
          orderNum: 3,
          text: 'Take this assessment on a laptop or device with a large screen – the images used for this assessment are not mobile-friendly',
        },
        {
          orderNum: 4,
          text: 'Please click the CONTINUE button to proceed.',
        },
      ],
      isInput: false,
      btnText: 'Continue',
    },
  },
  {
    type: 'INFO_INPUT',
    props: {
      textLines: [
        {
          orderNum: 1,
          text: 'On this task, you will have to remember lists of letters while simultaneously solving simple math problems. On each trial, you will receive a math problem, followed by a letter. Solve the math problem as quickly and accurately as you can, and remember the letter. At the end of a list, you will be asked to recall the list of letters in correct order.',
        },
        {
          orderNum: 2,
          text: 'Please click the CONTINUE button to proceed.',
        },
      ],
      isInput: false,
      btnText: 'Continue',
    },
  },
  {
    type: 'INFO_INPUT',
    props: {
      textLines: [
        {
          orderNum: 1,
          text: 'We will start by practicing the letter memory portion of the task. Try to remember the letters you see, then report them in the same order in which they appeared. On the test screen, click on the letters in the order they appeared. If you make a mistake and want to start over, clicking the "clear" button will clear the screen. When you are finished making your responses, click "submit."',
        },
        {
          orderNum: 2,
          text: 'Please click the CONTINUE button to proceed.',
        },
      ],
      isInput: false,
      btnText: 'Continue',
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'Q',
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'K',
    },
  },
  {
    type: 'LETTER_RECALL',
    props: {
      key: 'LETTER_RECALL',
      displayResult: true,
      grid: {
        1: 'F',
        2: 'P',
        3: 'Q',
        4: 'J',
        5: 'H',
        6: 'K',
        7: 'T',
        8: 'S',
        9: 'N',
        10: 'R',
        11: 'Y',
        12: 'L',
      },
      answers: [
        { index: 1, cell: 3 },
        { index: 2, cell: 6 },
      ],
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'P',
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'F',
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'N',
    },
  },
  {
    type: 'LETTER_RECALL',
    props: {
      key: 'LETTER_RECALL',
      displayResult: true,
      grid: {
        1: 'F',
        2: 'P',
        3: 'Q',
        4: 'J',
        5: 'H',
        6: 'K',
        7: 'T',
        8: 'S',
        9: 'N',
        10: 'R',
        11: 'Y',
        12: 'L',
      },
      answers: [
        { index: 1, cell: 2 },
        { index: 2, cell: 1 },
        { index: 3, cell: 9 },
      ],
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'S',
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'H',
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'J',
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'Y',
    },
  },
  {
    type: 'LETTER_RECALL',
    props: {
      key: 'LETTER_RECALL',
      displayResult: true,
      grid: {
        1: 'F',
        2: 'P',
        3: 'Q',
        4: 'J',
        5: 'H',
        6: 'K',
        7: 'T',
        8: 'S',
        9: 'N',
        10: 'R',
        11: 'Y',
        12: 'L',
      },
      answers: [
        { index: 1, cell: 8 },
        { index: 2, cell: 5 },
        { index: 3, cell: 4 },
        { index: 4, cell: 11 },
      ],
    },
  },
  {
    type: 'INFO_INPUT',
    props: {
      textLines: [
        {
          orderNum: 1,
          text: 'That is the end of the letter memory practice portion. Next we will practice the math portion of the task. On each trial, you will see a math problem that looks like this: (6 / 2) + 3 = ? After a short period, the screen will advance. You will then see a screen with a possible solution and two buttons: True and False. Click TRUE if the number is the correct solution, click FALSE if it is not.',
        },
        {
          orderNum: 2,
          text: 'Please click the CONTINUE button to proceed.',
        },
      ],
      isInput: false,
      btnText: 'Continue',
    },
  },
  {
    type: 'MATH_FLASHCARD',
    props: {
      key: 'MATH_FLASHCARD',
      problem: '(4 \\times 2) + 1 = ?',
    },
  },
  {
    type: 'MATH_ANSWER',
    props: {
      key: 'MATH_ANSWER',
      solution: '(4 \\times 2) + 1 = 7',
      displayResult: true,
      isCorrect: false,
    },
  },
  {
    type: 'MATH_FLASHCARD',
    props: {
      key: 'MATH_FLASHCARD',
      problem: '(1 \\times 4) + 3 = ?',
    },
  },
  {
    type: 'MATH_ANSWER',
    props: {
      key: 'MATH_ANSWER',
      solution: '(1 \\times 4) + 3 = 4',
      displayResult: true,
      isCorrect: false,
    },
  },
  {
    type: 'MATH_FLASHCARD',
    props: {
      key: 'MATH_FLASHCARD',
      problem: '(2 \\div 1) + 4 = ?',
    },
  },
  {
    type: 'MATH_ANSWER',
    props: {
      key: 'MATH_ANSWER',
      solution: '( 2 \\div 1) + 4 = 6',
      displayResult: true,
      isCorrect: true,
    },
  },
  {
    type: 'INFO_INPUT',
    props: {
      textLines: [
        {
          orderNum: 1,
          text: 'We will now start practice on the combined task. As a reminder, you will get a math problem, then a letter, and this pattern will repeat. At the end of the list, you will recall the letters in the same order in which they appeared.',
        },
        {
          orderNum: 2,
          text: 'Please click the CONTINUE button to proceed.',
        },
      ],
      isInput: false,
      btnText: 'Continue',
    },
  },
  // Combined test 1
  {
    type: 'MATH_FLASHCARD',
    props: {
      key: 'MATH_FLASHCARD',
      problem: '(3 \\div 3) - 1 = ?',
    },
  },
  {
    type: 'MATH_ANSWER',
    props: {
      key: 'MATH_ANSWER',
      solution: '(3 \\div 3) - 1 = 0',
      displayResult: true,
      isCorrect: true,
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'Q',
    },
  },
  {
    type: 'MATH_FLASHCARD',
    props: {
      key: 'MATH_FLASHCARD',
      problem: '(4 \\div 1) - 3 = ?',
    },
  },
  {
    type: 'MATH_ANSWER',
    props: {
      key: 'MATH_ANSWER',
      solution: '(4 \\div 1) - 3 = 1',
      displayResult: true,
      isCorrect: true,
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'K',
    },
  },
  {
    type: 'LETTER_RECALL',
    props: {
      key: 'LETTER_RECALL',
      displayResult: true,
      grid: {
        1: 'F',
        2: 'P',
        3: 'Q',
        4: 'J',
        5: 'H',
        6: 'K',
        7: 'T',
        8: 'S',
        9: 'N',
        10: 'R',
        11: 'Y',
        12: 'L',
      },
      answers: [
        { index: 1, cell: 3 },
        { index: 2, cell: 6 },
      ],
    },
  },
  // Combined test 2
  {
    type: 'MATH_FLASHCARD',
    props: {
      key: 'MATH_FLASHCARD',
      problem: '(6 \\div 1) - 2 = ?',
    },
  },
  {
    type: 'MATH_ANSWER',
    props: {
      key: 'MATH_ANSWER',
      solution: '(6 \\div 1) - 2 = 1',
      displayResult: true,
      isCorrect: false,
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'T',
    },
  },
  {
    type: 'MATH_FLASHCARD',
    props: {
      key: 'MATH_FLASHCARD',
      problem: '(4 \\div 1) + 4 = ?',
    },
  },
  {
    type: 'MATH_ANSWER',
    props: {
      key: 'MATH_ANSWER',
      solution: '(4 \\div 1) + 4 = 1',
      displayResult: true,
      isCorrect: false,
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'P',
    },
  },
  {
    type: 'MATH_FLASHCARD',
    props: {
      key: 'MATH_FLASHCARD',
      problem: '(3 \\div 3) + 7 = ?',
    },
  },
  {
    type: 'MATH_ANSWER',
    props: {
      key: 'MATH_ANSWER',
      solution: '(3 \\div 3) + 7 = 16',
      displayResult: true,
      isCorrect: false,
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'Y',
    },
  },
  {
    type: 'LETTER_RECALL',
    props: {
      key: 'LETTER_RECALL',
      displayResult: true,
      grid: {
        1: 'F',
        2: 'P',
        3: 'Q',
        4: 'J',
        5: 'H',
        6: 'K',
        7: 'T',
        8: 'S',
        9: 'N',
        10: 'R',
        11: 'Y',
        12: 'L',
      },
      answers: [
        { index: 1, cell: 7 },
        { index: 2, cell: 2 },
        { index: 3, cell: 11 },
      ],
    },
  },
  // Combined test 3
  {
    type: 'MATH_FLASHCARD',
    props: {
      key: 'MATH_FLASHCARD',
      problem: '(5 \\times 4) - 7 = ?',
    },
  },
  {
    type: 'MATH_ANSWER',
    props: {
      key: 'MATH_ANSWER',
      solution: '(5 \\times 4) - 7 = 13',
      displayResult: true,
      isCorrect: true,
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'S',
    },
  },
  {
    type: 'MATH_FLASHCARD',
    props: {
      key: 'MATH_FLASHCARD',
      problem: '(4 \\times 3) + 3 = ?',
    },
  },
  {
    type: 'MATH_ANSWER',
    props: {
      key: 'MATH_ANSWER',
      solution: '(4 \\times 3) + 3 = 11',
      displayResult: true,
      isCorrect: false,
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'K',
    },
  },
  {
    type: 'MATH_FLASHCARD',
    props: {
      key: 'MATH_FLASHCARD',
      problem: '(4 \\times 2) - 5 = ?',
    },
  },
  {
    type: 'MATH_ANSWER',
    props: {
      key: 'MATH_ANSWER',
      solution: '(4 \\times 2) - 5 = 2',
      displayResult: true,
      isCorrect: false,
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'H',
    },
  },
  {
    type: 'MATH_FLASHCARD',
    props: {
      key: 'MATH_FLASHCARD',
      problem: '(6 \\times 1) - 2 = ?',
    },
  },
  {
    type: 'MATH_ANSWER',
    props: {
      key: 'MATH_ANSWER',
      solution: '(6 \\times 1) - 2 = 4',
      displayResult: true,
      isCorrect: true,
    },
  },
  {
    type: 'LETTER_FLASHCARD',
    props: {
      key: 'LETTER_FLASHCARD',
      letter: 'R',
    },
  },
  {
    type: 'LETTER_RECALL',
    props: {
      key: 'LETTER_RECALL',
      displayResult: true,
      grid: {
        1: 'F',
        2: 'P',
        3: 'Q',
        4: 'J',
        5: 'H',
        6: 'K',
        7: 'T',
        8: 'S',
        9: 'N',
        10: 'R',
        11: 'Y',
        12: 'L',
      },
      answers: [
        { index: 1, cell: 8 },
        { index: 2, cell: 6 },
        { index: 3, cell: 5 },
        { index: 4, cell: 10 },
      ],
    },
  },
    {
      type: 'INFO_INPUT',
      props: {
        textLines: [
          {
            orderNum: 1,
            text: 'We will now start the real trials. The real trials will be like the combined lists you just completed. In this scored trial, your results will not be displayed.',
          },
          {
            orderNum: 2,
            text: 'Please click the CONTINUE button to proceed.',
          },
        ],
        isInput: false,
        btnText: 'Continue',
      },
    },
    // Trial 1
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(4 \\times 1) + 7 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(4 \\times 1) + 7 = 11',
        isCorrect: true,
        trial: 1,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'N',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(3 \\div 1) + 3 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(3 \\div 1) + 3 = 4',
        isCorrect: false,
        trial: 1,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'F',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(3 \\times 1) - 2 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(3 \\times 1) - 2 = 5',
        isCorrect: false,
        trial: 1,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'L',
      },
    },
    {
      type: 'LETTER_RECALL',
      props: {
        key: 'LETTER_RECALL',
        trial: 1,
        submitResults: true,
        grid: {
          1: 'F',
          2: 'P',
          3: 'Q',
          4: 'J',
          5: 'H',
          6: 'K',
          7: 'T',
          8: 'S',
          9: 'N',
          10: 'R',
          11: 'Y',
          12: 'L',
        },
        answers: [
          { index: 1, cell: 9 },
          { index: 2, cell: 1 },
          { index: 3, cell: 12 },
        ],
      },
    },
    // Trial 2
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(6 \\div 1) + 2 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(6 \\div 1) + 2 = 2',
        isCorrect: false,
        trial: 2,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'P',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(6 \\div 6) + 4 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(6 \\div 6) + 4 = 5',
        isCorrect: true,
        trial: 2,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'K',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(3 \\div 1) - 2 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(3 \\div 1) - 2 = 1',
        isCorrect: true,
        trial: 2,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'S',
      },
    },
    {
      type: 'LETTER_RECALL',
      props: {
        key: 'LETTER_RECALL',
        trial: 2,
        submitResults: true,
        grid: {
          1: 'F',
          2: 'P',
          3: 'Q',
          4: 'J',
          5: 'H',
          6: 'K',
          7: 'T',
          8: 'S',
          9: 'N',
          10: 'R',
          11: 'Y',
          12: 'L',
        },
        answers: [
          { index: 1, cell: 2 },
          { index: 2, cell: 6 },
          { index: 3, cell: 8 },
        ],
      },
    },
    // Trial 3
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(4 \\div 4) + 8 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(4 \\div 4) + 8 = 8',
        isCorrect: false,
        trial: 3,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'Q',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(1 \\times 4) + 3 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(1 \\times 4) + 3 = 4',
        isCorrect: false,
        trial: 3,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'H',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(6 \\div 1) - 2 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(6 \\div 1) - 2 = 1',
        isCorrect: false,
        trial: 3,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'P',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(4 \\times 2) + 3 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(4 \\times 2) + 3 = 11',
        isCorrect: true,
        trial: 3,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'Y',
      },
    },
    {
      type: 'LETTER_RECALL',
      props: {
        key: 'LETTER_RECALL',
        trial: 3,
        submitResults: true,
        grid: {
          1: 'F',
          2: 'P',
          3: 'Q',
          4: 'J',
          5: 'H',
          6: 'K',
          7: 'T',
          8: 'S',
          9: 'N',
          10: 'R',
          11: 'Y',
          12: 'L',
        },
        answers: [
          { index: 1, cell: 3 },
          { index: 2, cell: 5 },
          { index: 3, cell: 2 },
          { index: 4, cell: 11 },
        ],
      },
    },
    // Trial 4
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(1 \\div 1) + 1 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(1 \\div 1) + 1 = 2',
        isCorrect: true,
        trial: 4,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'F',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(3 \\div 3) + 8 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(3 \\div 3) + 8 = 14',
        isCorrect: false,
        trial: 4,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'J',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(1 \\div 1) + 5 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(1 \\div 1) + 5 = 5',
        isCorrect: false,
        trial: 4,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'L',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(5 \\div 1) - 5 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(5 \\div 1) - 5 = 10',
        isCorrect: false,
        trial: 4,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'R',
      },
    },
    {
      type: 'LETTER_RECALL',
      props: {
        key: 'LETTER_RECALL',
        trial: 4,
        submitResults: true,
        grid: {
          1: 'F',
          2: 'P',
          3: 'Q',
          4: 'J',
          5: 'H',
          6: 'K',
          7: 'T',
          8: 'S',
          9: 'N',
          10: 'R',
          11: 'Y',
          12: 'L',
        },
        answers: [
          { index: 1, cell: 1 },
          { index: 2, cell: 4 },
          { index: 3, cell: 12 },
          { index: 4, cell: 10 },
        ],
      },
    },
    // Trial 5
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(6 \\div 2) + 4 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(6 \\div 2) + 4 = 11',
        isCorrect: false,
        trial: 5,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'T',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(1 \\times 2) - 1 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(1 \\times 2) - 1 = 3',
        isCorrect: false,
        trial: 5,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'Q',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(2 \\div 1) + 4 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(2 \\div 1) + 4 = 6',
        isCorrect: true,
        trial: 5,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'F',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(6 \\div 6) + 4 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(6 \\div 6) + 4 = 5',
        isCorrect: true,
        trial: 5,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'N',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(6 \\div 6) + 9 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(6 \\div 6) + 9 = 10',
        isCorrect: false,
        trial: 5,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'Y',
      },
    },
    {
      type: 'LETTER_RECALL',
      props: {
        key: 'LETTER_RECALL',
        trial: 5,
        submitResults: true,
        grid: {
          1: 'F',
          2: 'P',
          3: 'Q',
          4: 'J',
          5: 'H',
          6: 'K',
          7: 'T',
          8: 'S',
          9: 'N',
          10: 'R',
          11: 'Y',
          12: 'L',
        },
        answers: [
          { index: 1, cell: 7 },
          { index: 2, cell: 3 },
          { index: 3, cell: 1 },
          { index: 4, cell: 9 },
          { index: 5, cell: 11 },
        ],
      },
    },
    // Trial 6
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(3 \\div 3) + 7 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(3 \\div 3) + 7 = 16',
        isCorrect: false,
        trial: 6,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'J',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(3 \\times 2) + 1 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(3 \\times 2) + 1 = 7',
        isCorrect: true,
        trial: 6,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'N',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(2 \\times 4) - 3 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(2 \\times 4) - 3 = 7',
        isCorrect: false,
        trial: 6,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'T',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(6 \\times 1) - 5 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(6 \\times 1) - 5 = 30',
        isCorrect: false,
        trial: 6,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'P',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(5 \\div 1) - 5 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(5 \\div 1) - 5 = 10',
        isCorrect: false,
        trial: 6,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'S',
      },
    },
    {
      type: 'LETTER_RECALL',
      props: {
        key: 'LETTER_RECALL',
        trial: 6,
        submitResults: true,
        grid: {
          1: 'F',
          2: 'P',
          3: 'Q',
          4: 'J',
          5: 'H',
          6: 'K',
          7: 'T',
          8: 'S',
          9: 'N',
          10: 'R',
          11: 'Y',
          12: 'L',
        },
        answers: [
          { index: 1, cell: 4 },
          { index: 2, cell: 9 },
          { index: 3, cell: 7 },
          { index: 4, cell: 2 },
          { index: 5, cell: 8 },
        ],
      },
    },
    // Trial 7
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(4 \\times 3) - 5 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(4 \\times 3) - 5 = 7',
        isCorrect: true,
        trial: 7,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'S',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(5 \\times 2) - 9 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(5 \\times 2) - 9 = 1',
        isCorrect: true,
        trial: 7,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'K',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(3 \\div 1) + 4 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(3 \\div 1) + 4 = 7',
        isCorrect: true,
        trial: 7,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'P',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(2 \\div 1) + 3 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(2 \\div 1) + 3 = 5',
        isCorrect: true,
        trial: 7,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'T',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(5 \\times 3) + 2 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(5 \\times 3) + 2 = 17',
        isCorrect: true,
        trial: 7,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'Q',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(4 \\times 3) + 3 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(4 \\times 3) + 3 = 11',
        isCorrect: false,
        trial: 7,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'J',
      },
    },
    {
      type: 'LETTER_RECALL',
      props: {
        key: 'LETTER_RECALL',
        trial: 7,
        submitResults: true,
        grid: {
          1: 'F',
          2: 'P',
          3: 'Q',
          4: 'J',
          5: 'H',
          6: 'K',
          7: 'T',
          8: 'S',
          9: 'N',
          10: 'R',
          11: 'Y',
          12: 'L',
        },
        answers: [
          { index: 1, cell: 8 },
          { index: 2, cell: 6 },
          { index: 3, cell: 2 },
          { index: 4, cell: 7 },
          { index: 5, cell: 3 },
          { index: 6, cell: 4 },
        ],
      },
    },
    // Trial 8
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(5 \\times 1) - 2 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(5 \\times 1) - 2 = 7',
        isCorrect: false,
        trial: 8,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'S',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(5 \\div 1) - 5 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(5 \\div 1) - 5 = 10',
        isCorrect: false,
        trial: 8,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'F',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(4 \\div 2) + 3 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(4 \\div 2) + 3 = 5',
        isCorrect: true,
        trial: 8,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'H',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(4 \\times 1) + 5 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(4 \\times 1) + 5 = 9',
        isCorrect: true,
        trial: 8,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'T',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(2 \\div 1) + 6 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(2 \\div 1) + 6 = 11',
        isCorrect: false,
        trial: 8,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'K',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(3 \\times 5) - 5 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(3 \\times 5) - 5 = 10',
        isCorrect: true,
        trial: 8,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'N',
      },
    },
    {
      type: 'LETTER_RECALL',
      props: {
        key: 'LETTER_RECALL',
        trial: 8,
        submitResults: true,
        grid: {
          1: 'F',
          2: 'P',
          3: 'Q',
          4: 'J',
          5: 'H',
          6: 'K',
          7: 'T',
          8: 'S',
          9: 'N',
          10: 'R',
          11: 'Y',
          12: 'L',
        },
        answers: [
          { index: 1, cell: 8 },
          { index: 2, cell: 1 },
          { index: 3, cell: 5 },
          { index: 4, cell: 7 },
          { index: 5, cell: 6 },
          { index: 6, cell: 9 },
        ],
      },
    },
    // Trial 9
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(5 \\times 2) - 4 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(5 \\times 2) - 4 = 6',
        isCorrect: true,
        trial: 9,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'Y',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(5 \\times 2) - 9 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(5 \\times 2) - 9 = 1',
        isCorrect: true,
        trial: 9,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'J',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(2 \\times 4) - 3 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(2 \\times 4) - 3 = 7',
        isCorrect: false,
        trial: 9,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'H',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(5 \\times 3) - 9 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(5 \\times 3) - 9 = 4',
        isCorrect: false,
        trial: 9,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'N',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(6 \\div 3) + 9 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(6 \\div 3) + 9 = 11',
        isCorrect: true,
        trial: 9,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'F',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(4 \\div 4) + 8 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(4 \\div 4) + 8 = 8',
        isCorrect: false,
        trial: 9,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'Q',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(1 \\div 1) + 5 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(1 \\div 1) + 5 = 5',
        isCorrect: false,
        trial: 9,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'P',
      },
    },
    {
      type: 'LETTER_RECALL',
      props: {
        key: 'LETTER_RECALL',
        trial: 9,
        submitResults: true,
        grid: {
          1: 'F',
          2: 'P',
          3: 'Q',
          4: 'J',
          5: 'H',
          6: 'K',
          7: 'T',
          8: 'S',
          9: 'N',
          10: 'R',
          11: 'Y',
          12: 'L',
        },
        answers: [
          { index: 1, cell: 11 },
          { index: 2, cell: 4 },
          { index: 3, cell: 5 },
          { index: 4, cell: 9 },
          { index: 5, cell: 1 },
          { index: 6, cell: 3 },
          { index: 7, cell: 2 },
        ],
      },
    },
    // Trial 10
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(4 \\div 1) + 5 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(4 \\div 1) + 5 = 7',
        isCorrect: false,
        trial: 10,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'Q',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(2 \\times 4) - 3 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(2 \\times 4) - 3 = 7',
        isCorrect: false,
        trial: 10,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'T',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(3 \\div 1) + 4 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(3 \\div 1) + 4 = 7',
        isCorrect: true,
        trial: 10,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'N',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(6 \\div 1) + 2 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(6 \\div 1) + 2 = 2',
        isCorrect: false,
        trial: 10,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'K',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(6 \\times 1) + 7 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(6 \\times 1) + 7 = 1',
        isCorrect: false,
        trial: 10,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'Y',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(6 \\div 1) + 3 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(6 \\div 1) + 3 = 9',
        isCorrect: true,
        trial: 10,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'R',
      },
    },
    {
      type: 'MATH_FLASHCARD',
      props: {
        key: 'MATH_FLASHCARD',
        problem: '(3 \\div 3) + 7 = ?',
      },
    },
    {
      type: 'MATH_ANSWER',
      props: {
        key: 'MATH_ANSWER',
        solution: '(3 \\div 3) + 7 = 16',
        isCorrect: false,
        trial: 10,
      },
    },
    {
      type: 'LETTER_FLASHCARD',
      props: {
        key: 'LETTER_FLASHCARD',
        letter: 'S',
      },
    },
    {
      type: 'LETTER_RECALL',
      props: {
        key: 'LETTER_RECALL',
        trial: 10,
        submitResults: true,
        complete: true,
        grid: {
          1: 'F',
          2: 'P',
          3: 'Q',
          4: 'J',
          5: 'H',
          6: 'K',
          7: 'T',
          8: 'S',
          9: 'N',
          10: 'R',
          11: 'Y',
          12: 'L',
        },
        answers: [
          { index: 1, cell: 3 },
          { index: 2, cell: 7 },
          { index: 3, cell: 9 },
          { index: 4, cell: 6 },
          { index: 5, cell: 11 },
          { index: 6, cell: 10 },
          { index: 7, cell: 8 },
        ],
      },
    },
    {
      type: 'INFO_INPUT',
      props: {
        textLines: [
          {
            orderNum: 1,
            text: 'Thank you for taking this assessment.',
          },
        ],
        isInput: false,
        btnText: 'End',
        finalStep: true,
      },
    },
  ],
};
